import { InlineDate, InlinePick, InlineText } from '@/components/ui'
import { useToast } from '@/hooks'
import type { CaseDetailCell } from './caseDetailCells'

const EMPTY_VALUE_PROMPT = 'Add'

interface CaseDetailValueProps {
  cell: CaseDetailCell
  onSave: (value: string) => Promise<void>
}

// One case answer, edited where it sits with the app's inline field for its kind.
export const CaseDetailValue = ({ cell, onSave }: CaseDetailValueProps) => {
  const { errorToast } = useToast()
  const title = `Edit ${cell.label.toLowerCase()}`

  const save = (value: string) => {
    if (value === cell.storedValue) return
    onSave(value).catch((error) =>
      errorToast(`Couldn’t save ${cell.label.toLowerCase()}`, error),
    )
  }

  if (cell.kind === 'select') {
    return (
      <InlinePick
        value={cell.storedValue}
        options={cell.options}
        placeholder={EMPTY_VALUE_PROMPT}
        title={title}
        className="text-sm"
        clearLabel={cell.isRequired ? undefined : 'Not set'}
        onPick={save}
      />
    )
  }

  if (cell.kind === 'date') {
    return (
      <InlineDate
        value={cell.storedValue}
        shown={cell.displayValue}
        placeholder={EMPTY_VALUE_PROMPT}
        title={title}
        className="text-sm"
        onCommit={save}
      />
    )
  }

  return (
    <InlineText
      value={cell.storedValue}
      placeholder={EMPTY_VALUE_PROMPT}
      title={title}
      className="text-sm"
      onCommit={save}
    />
  )
}
